import { Box } from "@mui/material";
import { TitleSwitchesProps } from "../utils/types";
import { SwitchWithDescription } from "@shared/components";

const TitleSwitches = ({ formikProps }: TitleSwitchesProps) => {
  const formikPropsForSwitch = {
    values: formikProps.values,
    touched: formikProps.touched,
    errors: formikProps.errors,
    setFieldValue: formikProps.setFieldValue,
    setFieldTouched: formikProps.setFieldTouched,
  };

  const switchConfigs = [
    {
      name: "pushEnabled",
      label: "Push Enabled",
      description:
        "Enables automatic synchronization, sending all remaining and upcoming data updates to the title database",
    },
    {
      name: "isActive",
      label: "Is Active",
      description:
        "Keeps the sync connection live. Once inactive, no updates will be pushed to the title database",
    },
  ] as const;

  return (
    <>
      {switchConfigs.map(({ name, label, description }) => (
        <Box key={name}>
          <SwitchWithDescription
            name={name}
            label={label}
            description={description}
            formik={formikPropsForSwitch}
          />
        </Box>
      ))}
    </>
  );
};

export default TitleSwitches;
